import React, { useState, useMemo } from "react";
import union from "../../images/union.svg";
import { FidgetSpinner } from "react-loader-spinner";
import { FaSpinner } from "react-icons/fa";

const CustomTable = ({
  columns = [],
  tableData = [],
  Filters = null,
  className = "",
  tableClass = "",
  noBorder = false,
  laoding = false,
  hasCheckboxes = false,
  selectedRows = [],
  onSelectedRowsChange = () => {},
  rowKey = "candidate_uuid",
}) => {
  const [sortKey, setSortKey] = useState(null);
  const [isCustomSort, setIsCustomSort] = useState(false);

  const allSelected = tableData.length > 0 && selectedRows.length === tableData.length;

  const toggleSelectAll = () => {
    if (allSelected) {
      onSelectedRowsChange([]);
    } else {
      onSelectedRowsChange(tableData.map((row) => row[rowKey]));
    }
  };

  const toggleRow = (id) => {
    if (selectedRows.includes(id)) {
      onSelectedRowsChange(selectedRows.filter((r) => r !== id));
    } else {
      onSelectedRowsChange([...selectedRows, id]);
    }
  };

  const borderClasses = {
    head : "border-t-0",
    lastHead : "border-t",
  };

  const handleSort = (col) => {
    if (!col.sortable) return;

    setSortKey((prev) => (prev === col.key ? null : col.key));

    if (col.sortFn) {
      setIsCustomSort(true);
      col.sortFn(); // use custom sort only
      return;
    }

    setIsCustomSort(false);
  };

  const sortedData = useMemo(() => {
    if (!sortKey || isCustomSort) return tableData;

    // Default sort logic (descending)
    return [...tableData].sort((a, b) => {
      const aValue = a[sortKey];
      const bValue = b[sortKey];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === "string" && typeof bValue === "string") {
        return bValue.localeCompare(aValue);
      }

      if (
        (aValue instanceof Date || !isNaN(Date.parse(aValue))) &&
        (bValue instanceof Date || !isNaN(Date.parse(bValue)))
      ) {
        return new Date(bValue) - new Date(aValue);
      }

      return bValue > aValue ? 1 : -1;
    });
  }, [tableData, sortKey, isCustomSort]);

  return (
    <div className="overflow-x-auto">
      {Filters && <div className="px-6 pt-6 pb-2">{Filters}</div>}

      <div className={`px-6 ${className}`}>
        {
          laoding ?
            <>
              <FaSpinner className="animate-spin my-20 mx-auto w-10 h-10" />
            </>
           :
          <table className={`min-w-full my-4 ${noBorder ? borderClasses.head : "border-t"} rounded-t-xl ${tableClass}`}>
          <thead className="sticky top-0 bg-white z-30 text-sm text-center">
            <tr>
              {hasCheckboxes && (
                <th
                  className={`py-4 px-4 text-center ${noBorder ? borderClasses.head : "border-y"}`}
                  style={{ width: "1%", whiteSpace: "nowrap" }}
                >
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={toggleSelectAll}
                    className="w-4 h-4 accent-web-blue cursor-pointer"
                  />
                </th>
              )}
              {columns.map((col) => {
                const isActive = sortKey === col.key;
                return (
                  <th
                    key={col.id || col.key}
                    className={`py-4 text-sm px-2 text-center ${
                      col.sortable ? "cursor-pointer hover:bg-gray-100" : ""
                    } ${noBorder ? borderClasses.head : "border-y"} ${col.className}`}
                    style={{ width: col.width || "auto" }}
                    onClick={() => handleSort(col)}
                  >
                    <div
                      className={`flex ${
                        col.notCentered ? "justify-start pl-2" : "justify-center"
                      } items-center gap-1 ${col.width === "fit-content" ? "w-fit" : ""}`}
                    >
                      {col.header}
                      {col.sortable && isActive && (
                        <img
                          src={union}
                          alt="sort"
                          style={{ width: 12, marginLeft: 4 }}
                          className="inline-block"
                        />
                      )}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>

          <tbody>
            {sortedData.length > 0 ? (
              sortedData.map((row, rowIndex) => (
                <tr key={rowIndex} className={`hover:bg-gray-50 ${hasCheckboxes && selectedRows.includes(row[rowKey]) ? "bg-blue-50" : ""}`}>
                  {hasCheckboxes && (
                    <td
                      className={`text-sm py-4 text-center px-4 ${noBorder ? borderClasses.lastHead : "border-y"}`}
                      style={{ width: "1%", whiteSpace: "nowrap" }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(row[rowKey])}
                        onChange={() => toggleRow(row[rowKey])}
                        className="w-4 h-4 accent-web-blue cursor-pointer"
                      />
                    </td>
                  )}
                  {columns.map((col) => (
                    <td
                      key={col.id || col.key}
                      className={`text-sm py-4 text-center p-2 ${noBorder ? borderClasses.lastHead : "border-y"}`}
                      style={{ width: col.width || "auto" }}
                    >
                      {col.body ? col.body(row,rowIndex) : row[col.key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length + (hasCheckboxes ? 1 : 0)}
                  className="text-center py-6 text-gray-500"
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
        }
      </div>
    </div>
  );
};

export default CustomTable;
